
<template>
  <div>
    <div>
      <el-row>
        <div class="left-justifying"><h3>作业内容</h3></div>
        <div class="right-justifying">
          <el-button type="info" plain size="small" @click="toAdd" v-if="addBtnExisted">
            <i class="fa fa-plus-circle"></i> 新建
          </el-button>
          <el-button type="info" plain size="small" @click="saveAdd" v-if="saveAddBtnExisted">
            <i class="fa fa-save"></i> 保存
          </el-button>
          <el-button type="info" plain size="small" @click="toEdit" v-if="editBtnExisted" :disabled="!editable">
            <i class="fa fa-pencil"></i> 修改
          </el-button>
          <el-button type="info" plain size="small" @click="saveEdit" v-if="saveEditBtnExisted">
            <i class="fa fa-save"></i> 保存
          </el-button>
          <el-button type="info" plain size="small" @click="cancelEdit" v-if="cancelEditBtnExisted">
            <i class="fa fa-undo"></i> 取消
          </el-button>
          <el-button type="info" plain size="small" @click="remove" v-if="deleteBtnExisted" :disabled="!deletable">
            <i class="fa fa-times"></i> 删除
          </el-button>
          <el-button type="info" plain size="small" @click="enabled" v-if="enabledBtnExisted">
            <i class="fa fa-power-off"></i> 启用
          </el-button>
          <el-button type="info" plain size="small" @click="abandon" v-if="abandonBtnExisted">
            <i class="fa fa-power-off"></i> 弃用
          </el-button>
          <WorkflowRequestBtn :visible="workflowBtnExisted" :use-new-api="true"
                              :bussiness="'3P'"
                              :bussinessId="detail.data.jobplanid"
                              :bussinessInfo="workflowBussinessInfo"
                              :disabled="workflowReopenBtnExisted"
                              @afterRequestWorkflowFunc="afterRequestWorkflowFunc"
                              >
          </WorkflowRequestBtn>
          <WorkflowReopenBtn :visible="workflowReopenBtnExisted" :use-new-api="true"
                              :bussiness="'3P'"
                              :bussinessId="detail.data.jobplanid"
                              :bussinessInfo="workflowBussinessInfo"
                              :disabled="false"
                              @afterRequestWorkflowFunc="afterRequestWorkflowFunc"
          >
          </WorkflowReopenBtn>
          <WorkflowDialog ref="workflowDialog"
                  :bussiness="'3P'"
                  :bussinessId="detail.data.jobplanid"
                  :workflowRequestInfo="workflowRequestInfo"
                  :dialogWorkflowVisible.sync="workflowDialogVisible"
                  :status-name="'3PDocumentSTATUS'"
                  @afterAuditWorkflowFunc="afterAuditWorkflowFunc">

          </WorkflowDialog>
        </div>
      </el-row>
    </div>
    <div class="panel">
      <div class="panel-body">
        <el-row>

          <div class="advanced-search-location">
            <AthubDropDownSearch v-model="list.search" model-path="list.search" @formDataSubmit="query" :formWidth="800" v-show="athubDropDownSearchShown" size="mini" collapseTags multiple>
              <el-form v-model="list.search" label-width="80px">
                <el-row type="flex" class="row-bg">
                  <el-col :span="11">
                    <el-form-item label="优先级">
                      <el-select v-model="list.search.eq_priority" clearable size="mini" class="width100">
                        <el-option
                                v-for="item in priorityDictionay.items"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value"
                                :disabled="item.disabled">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="MOP">
                      <el-radio-group v-model="list.search.eq_isstandard">
                        <el-radio :label="'YES'">是</el-radio>
                        <el-radio :label="'NO'">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" class="row-bg">
                  <el-col :span="11">
                    <el-form-item label="资产类型">
                      <domain-select :domainid="'ASSETTYPE'" v-model="list.search.cts_assettype" :multiple="false" size="mini" :filterable="true" clearable class="width100"></domain-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="设备型号">
                      <el-input v-model="list.search.like_equipmenttype" size="mini"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" class="row-bg">
                  <el-col :span="11">
                    <el-form-item label="发布日期">
                      <el-date-picker
                              size="mini"
                              v-model="list.search.range_releasedate"
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                              type="daterange"
                              placeholder="发布日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="录入时间">
                      <el-date-picker
                              size="mini"
                              v-model="list.search.range_enterdate"
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                              type="daterange"
                              placeholder="发布日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </AthubDropDownSearch>

            <el-tag v-show="activeTabName !== 'list'" type="danger" size="mini" style="margin-top: 9px;">
              状态：<dictionary-text :factory-name="'domain'" :params="'3PSTATUS'" :value="detail.data.status"></dictionary-text>
            </el-tag>
          </div>

          <el-tabs v-model="activeTabName" :before-leave="beforeLeave">
            <el-tab-pane label="列表" name="list">
              <jobplan-list ref="list" @switch-tab="switchTab" @switch-operation="switchOperation" @current-change="currentChange"></jobplan-list>
            </el-tab-pane>
            <el-tab-pane label="详情" name="detail">
              <jobplan-detail ref="detail" @switch-tab="switchTab" @switch-operation="switchOperation" :operation="operation" :data="detail.data" @current-change="currentChange"></jobplan-detail>
            </el-tab-pane>
            <el-tab-pane :label="stepTabLabel" name="step" v-if="stepTabExisted">
              <job-task-list :job-plan="detail.data" v-if="isSop || isMop || isInspect || isOther" @switch-operation="switchOperation"
                             :addable="editable" :updatable="editable" :deletable="editable"></job-task-list>
              <job-plan-scene-list :job-plan="detail.data" v-if="isEop" @switch-operation="switchOperation"
                                   :addable="editable" :updatable="editable" :deletable="editable"></job-plan-scene-list>
            </el-tab-pane>
            <el-tab-pane :label="'运行参数'" name="operate-param" v-if="operateParamTabExisted">
              <jobplan-operate-param ref="jobPlanOperateParam" :job-plan-id="detail.data.jobplanid"
                                     :addable="editable" :updatable="editable" :deletable="editable"></jobplan-operate-param>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script type="text/javascript">
  import AthubDropDownSearch from '@/components/common/athub.dropdown.search'
  import JobplanList from './list'
  import JobplanDetail from './detail'
  import JobTaskList from '@/views/workorder/jobplan/jobtask/list'
  import JobPlanSceneList from '@/views/workorder/jobplan/jobplanscene/list'
  import JobplanOperateParam from './operate-param'
  import DomainSelect from "../../../components/domainaln/index"
  import WorkflowRequestBtn from '@/components/workflow/workflowRequestBtn'
  import WorkflowReopenBtn from '@/components/workflow/workflowReopenBtn'
  import WorkflowDialog from '@/components/workflow/workflowDialog'
  import {merge} from '@/util/common'

  import {getJobPlanMixins} from './mixins'

  import {Dictionary, DICTIONARY_FACTORY_DOMAIN, dictionaryContainer} from '@/util/common/dictionary'

  import {WorkOrderServer} from '@/api'
  import DictionaryText from "../../../components/common/DictionaryText";
  import AthubCloudApi from '@/api/athubCloud'

  export default {
    name: 'JobplanIndex',
    componentName: 'JobplanIndex',
    mixins: [getJobPlanMixins({jobPlanKey: 'detail.data'})],
    components: {
      DictionaryText,
      DomainSelect,
      AthubDropDownSearch,
      WorkflowRequestBtn,
      WorkflowReopenBtn,
      WorkflowDialog,
      JobplanList,
      JobplanDetail,
      JobTaskList,
      JobPlanSceneList,
      JobplanOperateParam,
    },
    data(){
      return {
        current: {},
        activeTabName: 'list',
        statusText: '',
        operation: 'list',
        priorityDictionay: new Dictionary({
          items: [{
            value: 1,
            text: 1
          }, {
            value: 2,
            text: 2
          }, {
            value: 3,
            text: 3
          }]
        }),
        list: {
          search: {
            eq_priority: null,
            eq_isstandard: null,
            // eq_assettype: null,
            cts_assettype: null,
            like_equipmenttype: null,
            range_releasedate: null,
            range_enterdate: null,
            in_jobplanids: null,
          },
        },
        detail: {
          data: {
            status: 'DRAFT',
          },
        },

        operations: {},

        workflowDialogVisible: false,
        workflowRequestInfo: {},
      };
    },
    computed: {
      addBtnExisted() {
        return this.activeTabName === 'list';
      },
      editBtnExisted() {
        return this.operation === 'detail.show';
      },
      saveAddBtnExisted() {
        return this.operation === 'detail.add';
      },
      saveEditBtnExisted() {
        return this.operation === 'detail.edit';
      },
      cancelEditBtnExisted() {
        return this.operation === 'detail.edit';
      },
      deleteBtnExisted() {
        return this.operation === 'detail.show';
      },
      workflowBtnExisted() {
        return this.operation === 'detail.show' && this.is3P;
      },
      workflowReopenBtnExisted() {
        return this.operation === 'detail.show' && this.is3P && (this.detail.data['status'] === 'ACTIVE' || this.detail.data['status'] === 'INACTIVE');
      },
      workflowBussinessInfo() {
        let bussinessInfo = {};
        bussinessInfo.params = JSON.stringify({
          STATUS: this.detail.data.status
        });
        return bussinessInfo;
      },
      enabledBtnExisted() {
        return this.operation === 'detail.show' && this.detail.data['jobplanid'] != null && !this.is3P && this.detail.data['status'] !== 'ACTIVE';
      },
      abandonBtnExisted() {
        return this.operation === 'detail.show' && this.detail.data['jobplanid'] != null && !this.is3P && this.detail.data['status'] === 'ACTIVE';
      },
      athubDropDownSearchShown() {
        return this.activeTabName === 'list';
      },
      stepTabExisted() {
        return this.detail.data !== null && this.detail.data['type'] !== 'RMETER';
      },
      stepTabLabel() {
        let label = '步骤';
        if (this.detail.data !== null && this.detail.data['type'] === 'RINSPECT') {
          label = '巡检路线';
        }
        return label;
      },
      operateParamTabExisted() {
        return this.isSop || this.isMop;
      },
      editable() {
        return this.detail.data['status'] === 'DRAFT';
      },
      deletable() {
        return this.operations['deletable'] && this.operations['deletable']['success']
      },

    },
    methods: {
      beforeLeave(tabName, oldTabName) {
        // console.log(`beforeLeave tab: ${oldTabName} -> ${tabName}, operation: ${this.operation}`);

        if (oldTabName === 'detail' && (this.operation === 'detail.add' || this.operation === 'detail.edit')) {
          return this.$confirm('您输入的数据未保存，确认离开吗？', '离开提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.switchDefaultOperation(tabName);
            this.detail.data = this.current; // 回退原来的值
            return Promise.resolve();
          }, () => {
            return Promise.reject();
          })
        } else {
          this.switchDefaultOperation(tabName);
        }
        return Promise.resolve();
      },
      switchTab(tabName) {
        // console.log(`switchTab tab: ${this.activeTabName} -> ${tabName}, operation: ${this.operation}`);
        this.activeTabName = tabName;
      },
      switchOperation(operation) {
        // console.log(`switchOperation operation: ${this.operation} -> ${operation}`);
        this.operation = operation;
        switch (operation) {
          case 'list.query':
            this.query();
            break;
          case 'operate-param.refresh':
            this.$refs['jobPlanOperateParam'].refresh();
            break;
        }
      },
      switchDefaultOperation(tabName) {
        if (this.operation == null || this.operation.split('.')[0] !== tabName) {
          let operation = 'list';
          if (tabName === 'list') {
            operation = 'list';
          } else if (tabName === 'detail') {
            operation = 'detail.show';
          } else if (tabName === 'step') {
            operation = 'step'
          }
          this.switchOperation(operation);
        }
      },
      currentChange(current) {
        this.current = current;
      },
      query() {
        let pageSearch = {
          search: this.list.search
        };
        this.$refs['list'].$data.pageSearch = merge(true, {}, this.$refs['list'].$data.pageSearch, pageSearch);
      },
      toAdd() {
        this.switchTab('detail');
        this.switchOperation('detail.add');
        this.detail.data = {
          status: 'DRAFT'
        };
      },
      toEdit() {
        this.switchTab('detail');
        this.switchOperation('detail.edit');
      },
      saveAdd() {
        this.$refs['detail'].saveAdd();
      },
      saveEdit() {
        this.$refs['detail'].saveEdit();
      },
      cancelEdit() {
        this.$refs['detail'].cancelEdit();
      },
      remove() {
        this.$refs['detail'].remove();
      },
      afterRequestWorkflowFunc(a) {
        this.workflowDialogVisible = true;
        this.workflowRequestInfo = a;
      },
      afterAuditWorkflowFunc(businessInfo) {
        WorkOrderServer.jobPlan.workflowAudit(businessInfo).then((res) => {
          if (res.data.code === 200) {
            this.current = res.data.result.jobPlan;
            this.$refs.workflowDialog.close();
            this.workflowDialogVisible = false;
            this.$message.success('工作流发送成功！');
          } else {
            this.$message.error(res.data.message);
          }
        }, (error) => {
          this.$message.error(error);
        });
      },
      enabled() {
        function updateStatus(scope) {
          WorkOrderServer.jobPlan.updateStatus(scope.detail.data['jobplanid'], 'ACTIVE', scope.detail.data['status']).then((res) => {
            if (res.data.code === 200) {
              scope.$message.success('启用成功');
              scope.current = res.data.result;
            } else {
              scope.$message.error(res.data.message);
            }
          }, (error) => {
            scope.$message.error(error);
          });
        }
        if (this.detail.data['status'] === 'DRAFT') {
          this.$confirm('一旦启用将不能修改作业内容信息，请确定是否启用？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            updateStatus(this);
          }, () => {});
        } else {
          updateStatus(this);
        }
      },
      abandon() {
        WorkOrderServer.jobPlan.updateStatus(this.detail.data['jobplanid'], 'INACTIVE', this.detail.data['status']).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('弃用成功');
            this.current = res.data.result;
          } else {
            this.$message.error(res.data.message);
          }
        }, (error) => {
          this.$message.error(error);
        });
      }
    },
    watch: {
      current: {
        handler() {
          this.detail.data = this.current;
        }
      },
      'detail.data': {
        immediate: true,
        deep: true,
        handler() {
          console.log('detail.data change', this.detail.data);
          if (this.detail.data['jobplanid'] != null) {
            WorkOrderServer.jobPlan.getOperations(this.detail.data['jobplanid']).then((res) => {
              if (res.data.code === 200) {
                this.operations = res.data.result;
              } else {
                this.$message.error('获取');
              }
            }, (error) => {
              window.console.error(error);
            });
          }
        }
      },
      'list.search': {
        deep: true,
        handler() {
          this.query();
        }
      },
      'operation': {
        immediate: true,
        handler() {
          switch (this.operation) {
            case 'list.query':
              this.query();
              break;
            case 'operate-param.refresh':
              this.$refs['jobPlanOperateParam'].refresh();
              break;
          }
        }
      }
    },
    created() {

      this.$on('switch-tab', (tabName) => {
        this.switchTab(tabName);
      })

      this.$on('switch-operation', (operation) => {
        this.switchOperation(operation);
      });
    },
    mounted() {
      if (this.$route.query.source === 'index') {
        AthubCloudApi.fetchCurrentTaskIds('3P').then(res => {
          this.list.search.in_jobplanids = res;
        });
      } else {
        this.list.search.in_jobplanids = null;
      }
    }
  }

</script>